import React from 'react';
import './TenantSelection.scss';
import { Roles, SessionStorageKeys, ModalBodyIdentifiers } from '../../constants';
import { adminStateData } from './Constant';
import { TenantDisplay } from '../../DumpComponents/TenantDisplay/index';
import MoreIcon from '../../assets/icons/more.svg';
// import { UsersDetails } from '../MultiTenant/Model'; //future purpose
// import { Popup } from '../../DumpComponents/Popup';
// import ExpiryNotification from './ExpiryNotification';
// import { withErrorBoundary } from '../../Services/ErrorBoundary';

type TenantType = {
  tenantId: number;
  tenantName: string;
  tenantImageURL: string;
  isAdmin: boolean;
  noOfBot: number;
  noOfUser: number;
  lastModifiedOn: number;
  roleId: number;
};

type Props = {
  tenants: TenantType[];
  changeScreen: Function;
  // onSetTenant: (tenantId: number) => void;
  clickedTenant: Function;
  // onGetAllUsers: () => void;
  // onGetAllTenants: () => void;
  // role: string;
  // renderTenantMutationModal: (
  //   tenantName: string,
  //   imageURL: string,
  //   tenantId: number,
  //   modalBodyIdentifier: number
  // ) => void;
  renderTenantMutationModal: Function;
  // setPassExpCase: any;
  // userId: number;
  // history: any;
};

interface State {
  showPopup: number;
  showModal: boolean;
  modalBodyIdentifier: number;
  toasterConfig: {
    isVisible: boolean;
    toasterMessage: string;
  };
  // tenantAdmins: UsersDetails[];
  passExpMsg: string;
  PasswordUpdateSuccess: string;
}

class TenantSelection extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = adminStateData;
  }

  togglePopup = (e: any, value: any) => {
    e.stopPropagation();
    if (this.state.showPopup === value) {
      this.setState({ showPopup: 0 });
    } else {
      this.setState({ showPopup: value });
    }
  };

  hidePopup = () => {
    this.setState({ showPopup: 0 });
  };

  setPassExpMsg = () => {
    this.setState({
      passExpMsg: '',
    });
  };

  componentDidMount = () => {
    let PasswordUpdateSuccess = localStorage.getItem('PasswordUpdateSuccess');
    if (PasswordUpdateSuccess) {
      this.setState({
        PasswordUpdateSuccess: PasswordUpdateSuccess,
      });
      localStorage.removeItem('PasswordUpdateSuccess');
    } else if (window.sessionStorage) {
      const userData = window.sessionStorage.getItem(SessionStorageKeys.UserData);
      if (userData && JSON.parse(atob(userData)).notify) {
        if (JSON.parse(atob(userData)).passExp) {
          this.setState({
            passExpMsg: JSON.parse(atob(userData)).passExp,
          });
        }
      }
    }
  };

  componentDidUpdate = () => {
    let elem = document.querySelector('#sf-chatbot-container');
    if (elem) {
      document.body.removeChild(elem);
    }
  };
  render() {
    // const userData = window.sessionStorage.getItem(
    //   SessionStorageKeys.UserData
    // );

    return (
      <div className='tenant-selection-wrapper-new'>
        <div className='tenant-parent'>
          <div className='my-tenants'>My tenants</div>
          <div className='card-wrapper-main'>
            <div className='card-wrapper'>
              {this.props.tenants.map((eachTenant) => {
                return (
                  <div
                    className='card clickable'
                    key={eachTenant.tenantId}
                    // onClick={() => {
                    //   this.props.onSetTenant(eachTenant.tenantId);
                    //   // this.props.onGetAllUsers();
                    // }}
                    onClick={() => {
                      // this.props.changeScreen('MyHub');
                      this.props.clickedTenant(eachTenant);
                    }}>
                    <div className='card-body'>
                      <div
                        className='img-box'
                        style={{
                          visibility:
                            eachTenant.roleId === Roles.TENANTADMIN.id
                              ? 'visible'
                              : 'hidden',
                        }}>
                        <img
                          className='card-img'
                          src={MoreIcon}
                          alt='MoreIcon'
                          onClick={(e) => this.togglePopup(e, eachTenant.tenantId)}
                          id={`popup-opener-${eachTenant.tenantId}`}
                        />
                      </div>

                      {this.state.showPopup == eachTenant.tenantId ? (
                        // <Popup
                        //   alignment='right'
                        //   invokingElement={`#popup-opener-${eachTenant.tenantId}`}
                        //   clickOutsideCallback={this.hidePopup}
                        //   popupBodyWrapper='.popupView'
                        //   popupBody={
                        //     <div className='popupView'>
                        //       <div
                        //         onClick={(e) => {
                        //           e.stopPropagation();
                        //           this.setState({
                        //             showPopup: -1,
                        //           });
                        //           this.props.renderTenantMutationModal(
                        //             eachTenant.tenantName,
                        //             eachTenant.tenantImageURL,
                        //             eachTenant.tenantId,
                        //             ModalBodyIdentifiers.TenantProfile
                        //           );
                        //         }}>
                        //         Edit profile
                        //       </div>
                        //       <div
                        //         onClick={(e) => {
                        //           e.stopPropagation();
                        //           this.setState({
                        //             showPopup: -1,
                        //           });
                        //           this.props.renderTenantMutationModal(
                        //             eachTenant.tenantName,
                        //             eachTenant.tenantImageURL,
                        //             eachTenant.tenantId,
                        //             ModalBodyIdentifiers.TenantAdmins
                        //           );
                        //         }}>
                        //         Edit tenant admins
                        //       </div>
                        //     </div>
                        //   }></Popup>
                        <>
                          <div className='popupView'>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                this.setState({
                                  showPopup: -1,
                                });
                                this.props.renderTenantMutationModal(
                                  eachTenant.tenantName,
                                  eachTenant.tenantImageURL,
                                  eachTenant.tenantId,
                                  ModalBodyIdentifiers.TenantProfile
                                );
                              }}>
                              Edit profile
                            </div>
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                this.setState({
                                  showPopup: -1,
                                });
                                this.props.renderTenantMutationModal(
                                  eachTenant.tenantName,
                                  eachTenant.tenantImageURL,
                                  eachTenant.tenantId,
                                  ModalBodyIdentifiers.TenantAdmins
                                );
                              }}>
                              Edit tenant admins
                            </div>
                          </div>
                        </>
                      ) : null}

                      <div className='card-content'>
                        <TenantDisplay
                          renderType='type-2'
                          tenantImageURL={eachTenant.tenantImageURL}
                          tenantName={eachTenant.tenantName}
                        />
                        {eachTenant.isAdmin && (
                          <div>
                            <p className='mb-0'>
                              {`${eachTenant.noOfBot || 0} bots | ${
                                eachTenant.noOfUser || 0
                              } users`}
                            </p>
                            <p className='status'>{eachTenant.lastModifiedOn}</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* {this.state.passExpMsg ||
        this.state.PasswordUpdateSuccess === 'true' ? (
          <ExpiryNotification
            msg={
              this.state.PasswordUpdateSuccess === 'true'
                ? 'Your password was set successfully'
                : this.state.passExpMsg
            }
            type={
              this.state.PasswordUpdateSuccess === 'true'
                ? 'success'
                : 'warning'
            }
            setPassExpMsg={this.setPassExpMsg}
            setPassExpCase={this.props.setPassExpCase}
            userId={userData && JSON.parse(atob(userData)).userId}
            history={this.props.history}
          />
        ) : null} */}
      </div>
    );
  }
}

/* popup for tenant screen*/

interface PopupProps {
  popupView: React.ReactNode;
}

// export default withRouter(withErrorBoundary(TenantSelection));
export default TenantSelection;
